import React, { useState } from 'react';
import { getStorage, setStorage } from '../utils/storage';

const SettingsView = ({ isDarkMode }) => {
  const initialSettings = getStorage('settings') || {
    apiKey: '',
    saveHistory: true,
    notifyResults: false,
    autoClean: true,
    maxResults: 50
  };
  
  const [settings, setSettings] = useState(initialSettings);
  const [isSaving, setIsSaving] = useState(false);
  const [saveMessage, setSaveMessage] = useState('');

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSave = () => {
    setIsSaving(true);
    
    setTimeout(() => {
      setStorage('settings', settings);
      setSaveMessage('Configuración guardada correctamente');
      setIsSaving(false);
      
      setTimeout(() => {
        setSaveMessage('');
      }, 3000);
    }, 800);
  };

  return (
    <div className="h-full flex flex-col">
      <div className={`px-4 py-5 sm:px-6 border-b ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
        <h3 className={`text-2xl leading-6 font-bold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Configuración</h3>
        <p className={`mt-1 max-w-2xl text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
          Personaliza tu experiencia en Card Checker Pro.
        </p>
      </div>
      
      <div className="flex-1 overflow-auto p-6">
        <div className={`${isDarkMode ? 'bg-gray-800/70' : 'bg-white/90'} shadow-xl rounded-xl overflow-hidden backdrop-blur-sm border ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
          <div className="p-6">
            <div className="space-y-6">
              <div>
                <h4 className={`text-lg font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Configuración General</h4>
                <div className="mt-4 space-y-4">
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="save-history"
                        name="saveHistory"
                        type="checkbox"
                        checked={settings.saveHistory}
                        onChange={handleChange}
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label htmlFor="save-history" className={`font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Guardar historial</label>
                      <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Mantener un registro de las tarjetas verificadas en el checker.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="notify-results"
                        name="notifyResults"
                        type="checkbox"
                        checked={settings.notifyResults}
                        onChange={handleChange}
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label htmlFor="notify-results" className={`font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Notificar resultados</label>
                      <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Recibir notificaciones cuando se complete una verificación.</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        id="auto-clean"
                        name="autoClean"
                        type="checkbox"
                        checked={settings.autoClean}
                        onChange={handleChange}
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label htmlFor="auto-clean" className={`font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>Limpieza automática</label>
                      <p className={`${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>Limpiar automáticamente el historial después de cierto tiempo.</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className={`pt-5 border-t ${isDarkMode ? 'border-gray-700' : 'border-gray-200'}`}>
                <h4 className={`text-lg font-medium ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>Configuración Avanzada</h4>
                <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                  <div className="sm:col-span-4">
                    <label htmlFor="api-key" className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      API Key
                    </label>
                    <div className="mt-1">
                      <input
                        type="text"
                        name="apiKey"
                        id="api-key"
                        value={settings.apiKey}
                        onChange={handleChange}
                        className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border rounded-md p-2 ${isDarkMode ? 'bg-gray-700/50 border-gray-600 text-white placeholder-gray-500' : 'bg-gray-50 border-gray-300 text-gray-900 placeholder-gray-400'}`}
                        placeholder="Ingresa tu API Key para funcionalidades avanzadas"
                      />
                    </div>
                  </div>
                  
                  <div className="sm:col-span-2">
                    <label htmlFor="max-results" className={`block text-sm font-medium ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
                      Resultados máximos
                    </label>
                    <div className="mt-1">
                      <select
                        id="max-results"
                        name="maxResults"
                        value={settings.maxResults}
                        onChange={handleChange}
                        className={`shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border rounded-md p-2 ${isDarkMode ? 'bg-gray-700/50 border-gray-600 text-white' : 'bg-gray-50 border-gray-300 text-gray-900'}`}
                      >
                        <option value={10}>10 resultados</option>
                        <option value={25}>25 resultados</option>
                        <option value={50}>50 resultados</option>
                        <option value={100}>100 resultados</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="mt-6 flex justify-end">
              {saveMessage && (
                <div className="mr-4 text-sm text-green-600 self-center">
                  {saveMessage}
                </div>
              )}
              <button
                type="button"
                onClick={handleSave}
                disabled={isSaving}
                className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white ${
                  isSaving ? 'bg-indigo-400' : 'bg-indigo-600 hover:bg-indigo-700'
                } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors`}
              >
                {isSaving ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Guardando...
                  </>
                ) : 'Guardar Configuración'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsView;